import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Review from "./pages/Review";
import Toppick from "./pages/topPick";
import Practice from "./pages/practice";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main className="container">
          <Routes>
            <Route path="/" element={<Toppick />} />
            <Route path="/about" element={<About />} />
            <Route path="/Review" element={<Review />} />
            <Route path="/toppick" element={<Toppick />} />
            <Route path="/practice" element={<Practice />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
